import { FC } from 'react';

import { Box, Divider } from '@mui/material';

import { UserMenuOptions } from 'components';
import { useUserMenu } from 'hooks';
import { ChangeActiveUserModal } from 'components/ChangeActiveUser';
import { CommonDrawer } from '../CommonDrawer';
import { CloseDrawerButton } from '../CloseDrawerButton';
import { MobileSidebarHeader } from '../MobileSidebarHeader';
import { styles } from './styles';

interface UserAccountDrawerProps {
  isOpen: boolean;
  handleClose: () => void;
}

export const UserAccountDrawer: FC<UserAccountDrawerProps> = ({ isOpen, handleClose }) => {
  const {
    isBuyer,
    isModalOpen,
    isChangeUserModalOpen,
    handleCloseChangeUserModal,
    isMultiRole,
    hasMultiRole,
    clickChangeUser,
    changeActiveUser,
    handleCloseModal,
    handleOpenCompanyProfile,
    handleOpenModal,
    handleOpenChangePassword,
    handleGoToSavedProductsPage,
  } = useUserMenu({ onAction: handleClose });

  return (
    <>
      <CommonDrawer anchor="right" isOpen={isOpen} handleClose={handleClose}>
        <MobileSidebarHeader />
        <Box sx={styles.menuWrap}>
          <UserMenuOptions
            isBuyer={isBuyer}
            isModalOpen={isModalOpen}
            isMultiRole={isMultiRole}
            hasMultiRole={hasMultiRole}
            changeUser={clickChangeUser}
            handleOpenCompanyProfile={handleOpenCompanyProfile}
            handleOpenModal={handleOpenModal}
            handleCloseModal={handleCloseModal}
            handleOpenChangePassword={handleOpenChangePassword}
            handleGoToSavedProductsPage={handleGoToSavedProductsPage}
          />
          <Divider sx={styles.divider} />
        </Box>
        <ChangeActiveUserModal
          isOpen={isChangeUserModalOpen}
          handleClose={handleCloseChangeUserModal}
          changeActiveUser={changeActiveUser}
        />
      </CommonDrawer>
      {isOpen && <CloseDrawerButton position="left" handleClose={handleClose} />}
    </>
  );
};
